const fonts = {
    body: `"Poppins", sans-serif`,
    heading: `"Poppins", sans-serif`,
};
export default fonts;
